import { useInfiniteQuery } from "react-query";
import axios from "infra/http";
import { AutorizacaoItem, PortariaAutorizacaoFilter } from "../typings";
import { PaginateResult } from 'core/resources/types/shared';

function usePortariaAutorizacao(params: PortariaAutorizacaoFilter) {
  return useInfiniteQuery(
    [`/v1/portaria`, params],
    async ({ pageParam }) => {
      const { data } = await axios.get<PaginateResult<AutorizacaoItem>>(`/v1/portaria`, {
        params: {
          ...params,
          page: pageParam ?? 1,
        }
      });

      return data;

    },
    { getNextPageParam: (lastPage) => lastPage.meta.currentPage === lastPage.meta.totalPages ? undefined : lastPage.meta.currentPage + 1, refetchInterval: 30000 }
  );

  
}

export default usePortariaAutorizacao;
